module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/how-to-enjoy-sola-06-135e02de2b88ce4bf65b20512a9828c8.jpg";